import React, { useRef, useCallback, useState } from 'react';
import { useStatus, useAuthorization } from '@src/store/session';
import { UseUpdatePassword } from '@store/session/service';
import { Modal, Form, Input, message, Spin, Button } from 'antd';
import { encryptToBase64 } from '@src/utils';
import './update-password-modal.scss';
var prefixCls = 'update-password-modal';
var UpdatePasswordModal = function (props) {
    var onOk = props.onOk, onCancel = props.onCancel, userId = props.userId, visible = props.visible;
    var _a = useState({
        oldpwd: '',
        newpwd: '',
        cfmpwd: '',
    }), state = _a[0], setState = _a[1];
    var formRef = useRef(null);
    var updatingPwd = useStatus('updatingPwd');
    var token = useAuthorization();
    var handleOnValuesChange = useCallback(function (value, values) {
        if (formRef.current !== null) {
            setState(values);
        }
    }, []);
    var _b = UseUpdatePassword(), update = _b.mutateAsync, isLoading = _b.isLoading;
    var handleOk = useCallback(function () {
        var newpwd = state.newpwd, oldpwd = state.oldpwd;
        update({
            token: token,
            newpwd: encryptToBase64(newpwd, userId),
            oldpwd: encryptToBase64(oldpwd, userId),
        })
            .then(function () {
            message.success('更新成功');
            sessionStorage.setItem('reset', '0'); // 确定修改后不再弹窗
            onOk();
        })
            .catch(function (error) {
            message.error(error);
        });
    }, [state, update, token, userId, onOk]);
    return (React.createElement(Modal, { title: "\u4FEE\u6539\u5BC6\u7801", className: "" + prefixCls, visible: visible, width: 500, onCancel: onCancel, confirmLoading: updatingPwd, destroyOnClose: true, maskClosable: false, footer: null },
        React.createElement(Spin, { spinning: isLoading, tip: "\u6B63\u5728\u4FDD\u5B58..." },
            React.createElement(Form, { ref: formRef, name: "update-password", className: prefixCls + "_form", initialValues: state, hideRequiredMark: true, onFinish: handleOk, onValuesChange: handleOnValuesChange },
                React.createElement(Input, { hidden: true, name: "username", value: userId, autoComplete: "username" }),
                React.createElement(Form.Item, { name: "oldpwd", label: "\u539F\u5BC6\u7801", validateTrigger: ['onChange', 'onBlur'], rules: [{ required: true, message: '原密码不能为空' }] },
                    React.createElement(Input.Password, { className: "input-wrapper", autoComplete: "new-password", disabled: updatingPwd })),
                React.createElement(Form.Item, { name: "newpwd", label: "\u65B0\u5BC6\u7801", validateTrigger: ['onChange', 'onBlur'], rules: [
                        { required: true, whitespace: true, message: '密码不能为空' },
                        {
                            pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=\S+$).{6,20}$/,
                            message: '密码为6-20位数字和字母组合',
                        },
                    ] },
                    React.createElement(Input.Password, { className: "input-wrapper", autoComplete: "new-password", placeholder: "6-20\u4F4D\u6570\u5B57\u548C\u5B57\u6BCD\u7EC4\u5408", disabled: updatingPwd })),
                React.createElement(Form.Item, { name: "cfmpwd", label: "\u786E\u8BA4\u5BC6\u7801", dependencies: ['newpwd'], validateTrigger: ['onChange', 'onBlur'], rules: [
                        { required: true, message: '请确认密码' },
                        {
                            validator: function (rule, value, callback) {
                                // 写了新密码，并且和确认密码不相同
                                if (state.newpwd &&
                                    state.cfmpwd &&
                                    "" + state.newpwd !== "" + state.cfmpwd) {
                                    return callback('两次输入的密码不相同');
                                }
                                else {
                                    callback();
                                }
                            },
                        },
                    ] },
                    React.createElement(Input.Password, { className: "input-wrapper", autoComplete: "new-password", disabled: updatingPwd })),
                React.createElement(Form.Item, null,
                    React.createElement("div", { className: "commit" },
                        React.createElement(Button, { onClick: onCancel, style: { marginRight: '20px' } }, "\u53D6\u6D88"),
                        React.createElement(Button, { type: "primary", htmlType: "submit" }, "\u786E\u5B9A")))))));
};
export default React.memo(UpdatePasswordModal);
